import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Vaata juhendit

  <span style="color:#85c1dc;">**FI:**</span>
  Katso käsikirjaa

  <span style="color:#85c1dc;">**RU:**</span>
  См. инструкцию
*/
/* @__NO_SIDE_EFFECTS__ */
const m790 = msg(
  mf`Vaata juhendit`,
  mf`Katso käsikirjaa`,
  mf`См. инструкцию`,
)

export { m790 as 'w.module.product_description.manual_title' }